import type { PushTopic } from '../hooks/usePushSubscription';

/**
 * The push topics a reader can turn on, with the wording used both on each
 * topic's own page and in Settings' list of all of them.
 */
export const PUSH_TOPICS: ReadonlyArray<{
  topic: PushTopic;
  offLabel: string;
  onLabel: string;
}> = [
  {
    topic: 'btc15',
    offLabel: 'Notify me on UP/DOWN calls',
    onLabel: 'UP/DOWN call alerts on',
  },
  {
    topic: 'crash-bounce',
    offLabel: 'Notify me on Crash Bounce trades',
    onLabel: 'Crash Bounce alerts on',
  },
  {
    topic: 'breakout-watch',
    offLabel: 'Notify me on Breakout Watch trades',
    onLabel: 'Breakout Watch alerts on',
  },
  {
    topic: 'listing-radar',
    offLabel: 'Notify me on new Coinbase listings',
    onLabel: 'Listing radar alerts on',
  },
];

export function pushTopicLabels(topic: PushTopic): { offLabel: string; onLabel: string } {
  const { offLabel, onLabel } = PUSH_TOPICS.find((t) => t.topic === topic)!;
  return { offLabel, onLabel };
}
